import React from "react";
import { Link } from "react-router-dom";
import { PublicLayout, PageContainer } from "@/components/PublicLayout";
import { House } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <PublicLayout>
      <PageContainer className="py-24 text-center">
        <p className="font-heading font-black text-7xl text-brand">404</p>
        <h1 className="font-heading font-bold text-2xl text-slate-900 mt-4">Page not found</h1>
        <p className="text-slate-500 mt-2">The page you're looking for doesn't exist.</p>
        <Link to="/" data-testid="notfound-home-link" className="inline-flex items-center gap-2 mt-6 h-12 px-6 rounded-xl bg-brand text-white font-bold hover:bg-brand-hover transition-colors">
          <House className="w-5 h-5" weight="duotone" /> Back to Home
        </Link>
      </PageContainer>
    </PublicLayout>
  );
}
